import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, Typography } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import CustomQuotationComponent from './CASCOCustomQuotationComponent';
import { CardActionsContainer } from 'components/common/CardStyles';
import { customQuotationModalOpenVar } from '../../variables';

const CASCOCustomQuotationModalComponent = ({
  isNew,
  cascoCustomDataLens,
  insurers,
  conventions,
  risks,
  selectedRisks,
  currencyCode,
  onInsurerChange,
  onRiskSelectionChange,
  onDeleteSelectedRisk,
  onSave,
  onAmountChange,
  onPeriodInfoChange,
  validation,
  saveDisabled,
  saving,
  quotationLoading
}) => {
  const { t } = useTranslation();

  const closeModal = useCallback(() => customQuotationModalOpenVar(false), []);

  const actions = useMemo(
    () => (
      <CardActionsContainer mb={1} mr={1}>
        <Button color={'primary'} onClick={onSave} disabled={saveDisabled || saving}>
          {saving ? t('General.Saving') : t('General.Save')}
        </Button>
        <Button color={'primary'} onClick={closeModal}>
          {t('General.Close')}
        </Button>
      </CardActionsContainer>
    ),
    [onSave, saveDisabled, saving, t, closeModal]
  );

  return (
    <Dialog
      id='casco-custom-quotation-dialog'
      open={true}
      disableBackdropClick
      closeButtonProps={{ sx: { display: 'none' } }}
      fullWidth
      title={
        <Typography fontWeight='bold' color='primary'>
          {isNew ? t('Offer.Edit.Casco.AddCustomQuotation') : t('Offer.Edit.Casco.EditCustomQuotation')}
        </Typography>
      }
      maxWidth={'sm'}
      scroll={'paper'}
      content={
        <CustomQuotationComponent
          cascoCustomDataLens={cascoCustomDataLens}
          insurers={insurers}
          conventions={conventions}
          risks={risks}
          selectedRisks={selectedRisks}
          currencyCode={currencyCode}
          onInsurerChange={onInsurerChange}
          onRiskSelectionChange={onRiskSelectionChange}
          onDeleteSelectedRisk={onDeleteSelectedRisk}
          isNew={isNew}
          onAmountChange={onAmountChange}
          onPeriodInfoChange={onPeriodInfoChange}
          validation={validation}
          quotationLoading={quotationLoading}
        />
      }
      actions={actions}
    />
  );
};

CASCOCustomQuotationModalComponent.propTypes = {
  isNew: PropTypes.bool,
  cascoCustomDataLens: PropTypes.object,
  insurers: PropTypes.array,
  conventions: PropTypes.array,
  risks: PropTypes.array,
  selectedRisks: PropTypes.array,
  currencyCode: PropTypes.string,
  onInsurerChange: PropTypes.func,
  onRiskSelectionChange: PropTypes.func,
  onDeleteSelectedRisk: PropTypes.func,
  onSave: PropTypes.func,
  onAmountChange: PropTypes.func,
  onPeriodInfoChange: PropTypes.func,
  validation: PropTypes.object,
  saveDisabled: PropTypes.bool,
  saving: PropTypes.bool,
  quotationLoading: PropTypes.bool
};

export default CASCOCustomQuotationModalComponent;
